import { useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("flux_cookie_ok") === "1");
  if (dismissed) return null;

  const accept = () => {
    localStorage.setItem("flux_cookie_ok", "1");
    setDismissed(true);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-sm z-[60] bg-[#131f3a] border border-white/10 rounded-2xl p-4 shadow-2xl flex items-start gap-3" data-testid="cookie-banner">
      <Cookie className="w-5 h-5 text-[#f59e0b] shrink-0 mt-0.5" />
      <div className="space-y-2">
        <p className="text-[11px] text-gray-300 leading-relaxed">
          Flux uses one essential sign-in cookie and local storage for your preferences — no ad trackers. Details in our{" "}
          <Link to="/cookies" className="text-[#f59e0b] hover:underline">Cookie Policy</Link>.
        </p>
        <button onClick={accept} data-testid="cookie-accept-btn" className="bg-[#f59e0b] hover:bg-[#fbbf24] text-gray-950 font-bold text-[10px] font-mono px-3 py-1.5 rounded-lg transition-colors duration-200">
          GOT IT
        </button>
      </div>
    </div>
  );
}
